import React, {useEffect, useState} from "react";
import "./SendInfo.scss";
import {useHistory, useLocation} from "react-router-dom";
import {GetBasket, StoreOnlineAddress} from "../../Components/OnlineAddress/OnlineAddressService";
import {StoreOnlineCoupons, StoreOnlineSendInfo, StoreOnlineSetSendInfo} from "./SendInfoService";
import toaster from "toasted-notes";
import {OnlineAddress} from "../../Components";
import Shipping from "../../Components/Shipping/Shipping";
import {Modal} from "antd";
import ReactPlayer from "react-player";
import {CheckCircleOutlined} from '@ant-design/icons';
import moment from "moment-jalaali";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {editUser, getUser} from "../../Services";
import {useResp} from "../../hooks";
import BasketResponsive from "../BasketResponsive/BasketResponsive";
import SendResponsive from "../SendResponsive/SendResponsive";

function Error(props) {

    return (
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function SendInfo() {
    const history = useHistory();
    const location = useLocation();

    const [defaultAddress, set_defaultAddress] = useState({});
    const [times, set_times] = useState([]);
    const [radio, set_radio] = useState("");
    const [sendType, set_sendType] = useState(1);
    const [desc, set_desc] = useState("");
    const [merchant, set_merchant] = useState({});
    const [total , set_total] = useState(0);
    const [off , set_off] = useState(0);
    const [price , set_price] = useState(0);

    useEffect(() => {
        getBasket()
        getUserFunc()

        if(location?.state?.off)
            set_off(location?.state?.off);

        if(location?.state?.total)
            set_total(location?.state?.total);

        if(location?.state?.price)
            set_price(location?.state?.price);

    }, [])

    const getBasket = async () => {
        try {
            const response = await GetBasket();
            console.log("basket : ", response.data)
            if (response.data.merchant) {
                // getAddress(response.data.merchant.uid);
                set_merchant(response.data.merchant)
                getSendTime(response.data.merchant.uid);
            }
            if (response.data.address) {
                set_defaultAddress(response.data.address)
            }

        } catch (e) {
            console.log(e)
        }
    }

    const getAddress = async () => {
        const response = await StoreOnlineAddress();
        console.log("Add : ", response);
        let address = response.data.find(item => item.is_default)
        if (address) {
            set_defaultAddress(address)
        }
    }

    const getSendTime = async (merchantId) => {
        const response = await StoreOnlineSendInfo(merchantId, 1);
        console.log("times : ", response);
        set_times(response.data.results);
        let find = response.data.results.find(item => item.is_default);
        if (find)
            set_radio(find.uid)
    }


    const changeTime = async (id) => {
        // const response = await StoreOnlineSetSendInfo(id);
    }

    //drugstore mock flow -------------------------------------------------------
    const [bookModal, set_bookModal] = useState(false)
    const handleOk = () => {
        set_bookModal(false);
    };

    const handleCancel = () => {
        set_bookModal(false);
    };

    const [user,set_user]=useState({})
    const [fname,set_fname]=useState("")
    const [lname,set_lname]=useState("")
    const [mobile,set_mobile]=useState("")
    const getUserFunc = async () =>{
        try{
            let resp = await getUser()
            set_user(resp.data)
            set_mobile(resp.data.phone)
            set_lname(resp.data.last_name)
            set_fname(resp.data.first_name)
        }catch (e) {
            console.log(e)
        }
    }

    const editUserFunc = async () =>{

        if(fname.length<1 || lname.length<1)
           return toaster.notify(({onClose}) => (<Error message={"لطفا نام و نام خانوادگی را کامل نمایید"}/>), {duration: 2000});

        let user = {
            first_name:fname,
            last_name:lname
        }
        try{
            let resp = await editUser(user)
            let localUserString = localStorage.getItem('user')
            let localUser = JSON.parse(localUserString)
            let newUser = {...localUser,first_name:fname,last_name:lname}
            localStorage.setItem('user',JSON.stringify(newUser));


            //Send Info

            if (defaultAddress.address) {
                try {
                    // if(shipTime==="")
                    //     return toaster.notify(({ onClose }) => (<Error   message={"لطفا یک بازه زمانی انتخاب نمایید"}/>),{duration: 2000});

                    // else{
                    //     setTimeout(() =>{
                    //         set_bookModal(true)
                    //     },1000)
                    // }

                    const response = await StoreOnlineSetSendInfo(radio, desc,sendType,merchant.uid);
                    history.push("/online-store-payment")
                } catch (e) {
                    toaster.notify(({onClose}) => (<Error message={"مشکل در درخواست"}/>), {duration: 2000});
                }
            } else {
                toaster.notify(({onClose}) => (<Error message={"شما هیچ آدرس ثبت شده ای ندارید"}/>), {duration: 2000});
            }



        }catch (e) {
            console.log(e)
        }
    }


    const validate = async () => {

        editUserFunc()



    }

    const [shipTime, set_shipTime] = useState("")
    const [shipDate, set_shipDate] = useState(moment(new Date()).format("jYYYY/jMM/jDD"))

    const {height, width, mobileWidth} = useWindowDimensions();

    const resp = useResp()

    return (

        <>
            {resp?<SendResponsive
                set_desc={set_desc}
                desc={desc}
                price={price}
                set_fname={set_fname}
                fname={fname}
                lname={lname}
                mobile={mobile}
                set_lname={set_lname}
                set_mobile={set_mobile}
                off={off}
                total={total}
                times={times}
                set_radio={set_radio}
                changeTime={changeTime}
                radio={radio}
                editUserFunc={editUserFunc}
            />:null}
            {!resp?        <>
                <Modal visible={bookModal} footer={null} closable={false} onOk={handleOk}>
                    <div className="booking-modal">
                        <CheckCircleOutlined style={{fontSize: 46, color: "#9adb9a"}}/>
                        <br/>
                        <span
                            className="booking-modal-message">{` درتاریخ ${shipDate} از ساعت ${shipTime.from + " تا " + shipTime.to} کارشناس برای گرفتن نمونه به محل شما مراجعه می نماید`}</span>
                        <span className="booking-modal-hint">لطفا در تاریخ و ساعت ذکر شده در محل حضور داشته باشید</span>
                        <span className="booking-modal-text" onClick={() => {
                            history.push("/reward")
                        }}>تایید و پرداخت</span>
                    </div>
                </Modal>
                <div className="basket-brand">
                    <img src={merchant.thumbnail} alt=""/>
                </div>

                <div className="online-sendinfo-container">
                    <div className="sinfo-wr" style={{margin: "0 16px"}}>


                        <div className="online-header-section"
                             style={{width: mobileWidth ? mobileWidth : document?.getElementById('mobile-sec')?.clientWidth}}>
                            <i className="fa fa-arrow-left"
                               onClick={() => {
                                   history.goBack()
                               }}
                            ></i>
                            <span>ارسال اطلاعات</span>
                        </div>


                        <div className="address-section">
                            <span className="title">آدرس تحویل سفارش</span>
                            {/*<span className="address">{defaultAddress.address}</span>*/}
                            {merchant.uid?<OnlineAddress merchantId={merchant?.uid}/>:null}
                        </div>

                        {/*<h1 onClick={e=>{*/}
                        {/*    history.push(`/online-store-basket/${merchant?.uid}`)*/}
                        {/*}}>dsfsdflk</h1>*/}

                        <div className="address-section">
                            <span className="title">توضیحات سفارش</span>
                            <textarea
                                value={desc}
                                onChange={(e) => {
                                    set_desc(e.target.value)
                                }} rows="4" cols="50">
                </textarea>
                        </div>

                        <div className="address-section">
                            <span className="title">اطلاعات کاربر</span>
                            <div className="profile-section">
                                <input
                                    onChange={e=>set_fname(e.target.value)}
                                    value={fname}
                                    type="text" name="" id="" placeholder={"نام"}/>
                                <input
                                    onChange={e=>set_lname(e.target.value)}
                                    value={lname}
                                    type="text" name="" id="" placeholder={"نام خانوادگی"}/>
                                <input
                                    onChange={e=>set_mobile(e.target.value)}
                                    value={mobile}
                                    type="text" name="" id="" placeholder={"موبایل"} disabled={true}/>
                            </div>
                        </div>


                        {/*<span className="title">زمان ارسال</span>*/}

                        {/*<Shipping selDate={set_shipDate} selTime={set_shipTime}/>*/}

                        {/*<div className="in-person-sec">*/}
                        {/*    <span>مراجعه حضوری</span>*/}
                        {/*    <input type="checkbox" name="" id=""/>*/}
                        {/*</div>*/}

                        {/*<div className="send-time-section" style={{visibility: "visible"}}>*/}
                        {/*    <span className="title">نوع ارسال</span>*/}


                        {/*    <div className="send-time-list">*/}


                        {/*        <div className="send-time-item" onClick={() => {*/}
                        {/*            set_sendType(2);*/}
                        {/*        }}>*/}
                        {/*            <span>پیک میاره</span>*/}
                        {/*            <input*/}
                        {/*                type="radio" name="tsend" id="" value={sendType}*/}
                        {/*                checked={sendType === 2}/>*/}
                        {/*        </div>*/}

                        {/*        <div className="send-time-item"  onClick={() => {*/}
                        {/*            set_sendType(1);*/}
                        {/*        }}>*/}
                        {/*            <span>پیک مرچنت</span>*/}
                        {/*            <input*/}
                        {/*                type="radio" name="tsend" id="" value={sendType}*/}
                        {/*                checked={sendType === 1}/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="send-time-section" style={{visibility: "visible"}}>
                            <span className="title">زمان ارسال</span>


                            <div className="send-time-list">
                                {times.map(item => {
                                    return (
                                        <div className="send-time-item">
                                            <span>{item.title}</span>
                                            <input

                                                onClick={() => {
                                                    set_radio(item.uid);
                                                    changeTime(item.uid)
                                                }}
                                                type="radio" name="send" id="" value={item.uid}
                                                checked={radio === item.uid}/>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>


                        <div className="online-product-footer"
                             style={{width: mobileWidth ? mobileWidth : document?.getElementById('mobile-sec')?.clientWidth}}>
                            <div className="notAdded-mode">
                                <div className="add-to-basket-btn" onClick={() => {
                                    validate();

                                }}>
                                    <span>ادامه</span>
                                    {/*<span>رزرو</span>*/}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="online-product-footer-md">
                    <div className="notAdded-mode-md">
                        <div className="add-to-basket-btn" onClick={() => {
                            validate();
                        }}>
                            <span>ادامه فرایند خرید</span>
                        </div>
                        <div className="add-to-basket-btn" onClick={() => {
                            history.goBack()
                        }}>
                            <span>برگشت</span>
                        </div>
                    </div>
                </div>
            </>
            :null}
            </>
    )
}

export {SendInfo};
